import { getCookie, getSecondLevelDomain, setCookie } from '../lib';
var getPreviousPage = function (page, type) {
    var hostname = getSecondLevelDomain();
    var options = {};
    if (hostname !== null) {
        options.domain = hostname;
    }
    var cookieName = type === 'nwt' ? 'nwtPrevPage' : 'prevPage';
    var prevPage = getCookie(cookieName) || 'FirstPageOfVisit';
    if (page) {
        // @ts-ignore JS function not properly typed yet
        setCookie(cookieName, page, 1800000, options);
    }
    return prevPage;
};
export default getPreviousPage;
